<script>
import Chart from "@/components/widgets/chart";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Paid': 'Pago',
      'Forecast': 'Previsão',
      'Total': 'Total',
    },
    es: {
      'Paid': 'Pagado',
      'Forecast': 'Previsión',
      'Total': 'Total',
    },
  },
  components: { Chart },
  data() {
    return {
      empty: true,

      resume: {
        paid: 0,
        prediction: 0,
        total: 0
      },

      chartdata: {},
      options: {}
    }
  },
  methods: {
    getChart() {
      api
        .get('chart/bonus')
        .then(response => {
          if (response.data.status == 'success') {
            this.resume = response.data.chart.resume;

            this.chartdata = {
              labels: response.data.chart.labels,
              datasets: [
                {
                  label: this.t('Total'),
                  backgroundColor: ["#1F74A8", "#1F74A8", "#1F74A8", "#1F74A8", "#1F74A8", "#1F74A8", "#1F74A8", "#1F74A8"],
                  data: response.data.chart.data,
                }
              ]
            }

            this.options = {
              defaultFontColor: '#6DA544',
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                xAxes: [
                  {
                    ticks: {
                      maxTicksLimit: 10,
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      max: response.data.chart.max,
                      min: 0,
                      stepSize: response.data.chart.step,
                    },
                  },
                ],
              },
            }

            this.empty = false
          } else {
            this.empty = true
          }
        })
    }
  },
  mounted() {
    this.getChart();
  },
}
</script>

<template>
  <div class="w-100">
    <div class="d-flex flex-wrap flex-gap-10 mb-4">
      <div class="flex-fill">
        <div class="card mb-0">
          <div class="card-body text-center p-2">
            <h5 class="my-1">{{ resume.paid | currency }}</h5>
            <div class="bg-default rounded py-1 font-size-12 text-uppercase text-white font-weight-medium">{{ t('Paid') }}</div>
          </div>
        </div>
      </div>
      <div class="flex-fill">
        <div class="card mb-0">
          <div class="card-body text-center p-2">
            <h5 class="my-1">{{ resume.prediction | currency }}</h5>
            <div class="bg-default rounded py-1 font-size-12 text-uppercase text-white font-weight-medium">{{ t('Forecast') }}</div>
          </div>
        </div>
      </div>
      <div class="flex-fill">
        <div class="card mb-0">
          <div class="card-body text-center p-2">
            <h5 class="my-1">{{ resume.total | currency }}</h5>
            <div class="bg-default rounded py-1 font-size-12 text-uppercase text-white font-weight-medium">{{ t('Total') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="empty"></div>
    <div v-else>
      <Chart :chartdata="chartdata" :options="options"></Chart>
    </div>
  </div>
</template>